import { saveAs } from 'file-saver';

export default class ExcelDownload {
    // payload = {
    //     name: 'carros'   
    //     header: ['cor', 'ano', 'marca', 'modelo'],
    //     body: [
    //         ['azul', '2017', 'honda', 'civic'],
    //         ['laranja', '2005', 'ford', 'fiesta'],
    //         ['preto', '2022', 'fiat', 'fastback'],
    //     ]
    // }
    // excel:
    // cor    | ano   | marca   | modelo 
    // azul   | 2017  | honda   | civic 
    // laranja| 2005  | ford    | fiesta 
    // preto  | 2022  | fiat    | fastback

    constructor(payload) {
        const XLSX = require('sheetjs-style');
        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "SheetJS",
            Subject: "Recompra",
            Author: "Club da Cotação",
            CreatedDate: new Date()
        };
        wb.SheetNames.push('Produtos');
        var ws_data = [['Código', 'Descrição', 'Tip. Emb' , 'Qtd. Emb.', 'Estoque', 'Estoq. Sug.', 'Sugestão', 'Pedido', 'Cod. Cat.', 'Cat. Nome','Observação', 'Custo','Vlr. Cx','Prc Venda','Margem',  'Fornecedor', 'Vendedor'], ...payload]; 
        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws["!cols"] = [ { wch: 10 }, { wch: 60 }, { wch: 9 }, { wch: 8 },{ wch: 9 },{ wch: 9 },{ wch: 9 }, { wch: 8 },{ wch: 9 },{ wch: 9 },{ wch: 15 },{ wch: 10 },{ wch: 10 },{ wch: 10 },{ wch: 10 },{ wch: 10 }]
        const header = {
            font: {
                bold: true,
                italic: true
            },
            fill:{
                fgColor: { rgb: "9bbb59" }
            },
            border:{
                bottom: {style: 'thin', color: '737272'},
                right: {style: 'thin', color: '737272'},
            }
        }
        const obs = {
            font: {
                color: { rgb: "FF72760" }
            }
        }
        ws["A1"].s = header
        ws["B1"].s = header
        ws["C1"].s = header
        ws["D1"].s = header
        ws["E1"].s = header
        ws["F1"].s = header
        ws["G1"].s = header
        ws["H1"].s = header
        ws["I1"].s = header
        ws["J1"].s = header
        ws["K1"].s = header
        ws["L1"].s = header
        ws["M1"].s = header
        ws["N1"].s = header
        ws["O1"].s = header
        ws["P1"].s = header
        ws["Q1"].s = header

        for (let index = 2; index < 5000; index++) {
            if(ws["K"+index]) ws["K"+index].s = obs
            else break;
        }
        
        wb.Sheets['Produtos'] = ws;


        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
        saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), 'Produtos' + '.xlsx');
    }
}